<template>
  <div class="sub-sections">
    <div class="items">
      <div
          class="item" v-for="section in subSectionsList" :key="section"
          @click="navigate(section)">
        <img :src="section.image">
        <span>{{section.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'SubSections',
  props : {
    subSectionsList : Array
  },
  components: {

  },
  data() {
    return {

    }
  },
  async mounted() {

  },
  methods : {
    navigate : function(section) {
      this.$router.push(
          {
            name:'catalog_section',
            params: {section: section.code}
          }
      )
    }
  }
}
</script>

<style scoped>

.sub-sections .items{
  display: flex;
  gap: 10px;
  overflow: auto;
  padding-bottom: 18px;
  border-bottom: 1px solid #DFDFDF;
  margin-bottom: 18px;
}

.sub-sections .items::-webkit-scrollbar {
  width: 4px; /* Ширина всего элемента навигации */
  height: 4px;
}

.sub-sections .items::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

.sub-sections .items::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}

.item {
  display: flex;
  align-items: center;
  gap: 12px;

  cursor: pointer;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 10px;
}

.item img{
  width: 40px;
  height: 40px;
}

.item span{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  white-space: nowrap;
}




/*MOBILE*/
@media (max-width: 1250px)
{
  .sub-sections {

  }

  .sub-sections .items{
    flex-direction: column;
    gap: 8px;
    padding-bottom: unset;
    border-bottom: unset;
    margin-bottom: 20px;
  }

  .sub-sections .item span{
    white-space: unset;
  }
}
</style>


